"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isExternalRoleMapping = void 0;
var account_api_1 = require("@newfront-insurance/account-api");
var EXTERNAL_ROLE_IDS_SET = new Set(account_api_1.EXTERNAL_ROLE_IDS);
function isExternalRoleMapping(accountRoleMapping) {
    return EXTERNAL_ROLE_IDS_SET.has(accountRoleMapping.roleId);
}
exports.isExternalRoleMapping = isExternalRoleMapping;
//# sourceMappingURL=external-role-mappings.js.map